module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Armless Wedge Sofa_Ocean.52d42393.png";